<template>
    <div>
        <v-container grid-list-xl fluid>
            <DataTable :url="url" :enable-delete="false" descending :sortable="false"
                       :enable-edit="false" :enable-add="false" disable-search
                       :title="false" :titles="titles" :actions-extra-main="actionsExtraMain"
                       :fields-hidden-main="['updated_at','subject_id','subject_type','author_type','author_id','subject']"
                       :formatter="formatters"></DataTable>
        </v-container>
        <v-dialog v-if="ride_id" fullscreen lazy v-model="ride_page_dialog">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-btn icon dark @click="ride_page_dialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Ride Details</v-toolbar-title>
                </v-toolbar>
                <ride-page :ride_id="ride_id"/>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import DataTable from '@/components/wasilni/DataTable';
    import moment from 'moment';
    import VWidget from "@/components/VWidget";
    import RidePage from "@/views/RidePage";

    export default {
        name: "passenger_bookings",
        components: {RidePage, DataTable, VWidget},
        props: ['id'],
        data() {
            return {
                ride_page_dialog: false,
                ride_id: null,
                url: '',
                titles: {
                    id: 'ID',
                    status: "Status",
                    datetime: "Datetime",
                    created_at: 'Created At',
                },
                loading: false,
                formatters: {
                    datetime(value) {
                        return moment(value).format('hh:mm A, DD MMM YYYY');
                    },
                    created_at(value) {
                        return moment(value).format('hh:mm A, DD MMM YYYY');
                    }
                }
            };
        },
        computed: {
            actionsExtraMain() {
                return {
                    revoke: {
                        title: "Details",
                        icon: 'info',
                        extras: {
                            medium: true
                        },
                        action: (item) => {
                            if (item.ride_id) {
                                this.ride_id = item.ride_id;
                                this.ride_page_dialog = true;
                            }
                        }
                    }
                };
            }
        },
        mounted() {
            this.url = `passenger/${this.id}/bookings`;
        }
    }
</script>

<style scoped>

</style>